"use client";
import React, { useEffect, useState } from "react";

const ClothBanner = () => {
  const [snowflakes, setSnowflakes] = useState<number[]>([]);

  useEffect(() => {
    const flakes = Array.from({ length: 60 }, () => Math.random() * 100);
    setSnowflakes(flakes);
  }, []);

  const banner: React.CSSProperties = {
    width: "100%",
    minHeight: "600px",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    textAlign: "center",

    // 🔥 Dark Black Shade + Background Image
    backgroundImage:
      "linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url('https://res.cloudinary.com/norrona/image/upload/x_4317,y_2877,w_8633,h_4856,c_crop,g_xy_center/b_rgb:fcfcfc/c_pad,f_auto,d_imgmissing.jpg,fl_progressive.lossy,q_auto,w_1956/Auto%2FFW2526-femund-norrona_femunden_winter_sjut_sverrehjornevik-4436.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const textContainer: React.CSSProperties = {
    position: "relative",
    zIndex: 2,
    maxWidth: "900px",
    padding: "0 20px",
    animation: "fadeSlide 1.2s ease",
  };

  const title: React.CSSProperties = {
    fontSize: "4rem",
    fontWeight: 900,
    marginBottom: "20px",
    lineHeight: 1.2,
    color: "#fff",
    textShadow: "3px 3px 15px rgba(0,0,0,0.9)",
    fontFamily: "'Montserrat', sans-serif",
  };

  const subtitle: React.CSSProperties = {
    fontSize: "1.5rem",
    fontWeight: 500,
    marginBottom: "30px",
    color: "#f1f1f1",
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    fontFamily: "'Montserrat', sans-serif",
  };

  const button: React.CSSProperties = {
    padding: "16px 40px",
    fontSize: "1rem",
    fontWeight: 700,
    color: "#000",
    background: "#fff",
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 10px 25px rgba(255,255,255,0.3)",
  };

  const snowflakeStyle = (left: number): React.CSSProperties => ({
    position: "absolute",
    top: "-10px",
    left: `${left}%`,
    width: "7px",
    height: "7px",
    background: "#fff",
    borderRadius: "50%",
    opacity: 0.9,
    animation: `snowFall ${5 + Math.random() * 4}s linear infinite`,
    animationDelay: `${Math.random() * 3}s`,
    zIndex: 1,
    filter: "blur(1px)",
  });

  const keyframes = `
    @keyframes fadeSlide {
      0% { opacity: 0; transform: translateY(25px); }
      100% { opacity: 1; transform: translateY(0); }
    }

    @keyframes snowFall {
      0% { transform: translateY(0) rotate(0deg); opacity: 0.9; }
      100% { transform: translateY(700px) rotate(360deg); opacity: 0.3; }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>

      <div style={banner}>
        {/* Snow Layer */}
        {snowflakes.map((left, index) => (
          <div key={index} style={snowflakeStyle(left)}></div>
        ))}

        {/* Text */}
        <div style={textContainer}>
          <h1 style={title}>Winter Collection 2025</h1>
          <p style={subtitle}>Experience Premium Black Edition Outfits</p>
          <button style={button}>Shop Now</button>
        </div>
      </div>
    </>
  );
};

export default ClothBanner;
